import React from 'react'
import { observer } from 'mobx-react'
import isArray from 'lodash/isArray'
import isFunction from 'lodash/isFunction'
import { Form } from 'react-bootstrap'
import colorCode from 'src/static/fixtures/colorCode.json'
import {
  i18nTranslate,
  application,
  enablePlpRedesign,
  currencyFormat,
  isFeatureEnabled,
} from 'src/utils'
import './styles.scss'
import { viewMoreIcon, viewLessIcon } from './fixture'

@observer
class ListView extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      showAll: false,
    }
  }
  /* 
  discussed this with poovarasan, 
  for filter labels, sorting will be done in backend
  https://nuskin.atlassian.net/browse/CX26-676

  sortValues = values => {
    if (
      this.props.filterKey?.toLowerCase() == 'range_facet_price' ||
      this.props.filterKey?.toLowerCase() == 'range_facet_wholesaleprice'
    ) {
      let startingFilterItem = []
      let remainingFilters = []
      // first filter item should be starting with "UP TO"
      // example: "UP TO 250"
      // confirmed with Magudeswaran for CX121-2952
      values?.forEach(filterItem => {
        if (
          filterItem?.name?.toLowerCase()?.includes('up to') ||
          filterItem?.name?.toLowerCase()?.includes('under')
        ) {
          startingFilterItem.push(filterItem)
        } else {
          remainingFilters.push(filterItem)
        }
      })
      return [
        ...startingFilterItem,
        ...sortBy(remainingFilters, filterItem => {
          try {
            const priceRangeStartingValue =
              filterItem?.name?.split(' ')?.[0] || ''
            // CX121-3021
            // for price, sorting to be done using on string received
            // as "1"000 displayed before "2"50 --> so using parseInt
            return priceRangeStartingValue
              ? parseInt(priceRangeStartingValue)
              : filterItem?.name
          } catch (e) {
            console.log('error while sorting price filter facets')
          }
          return filterItem?.name
        }),
      ]
    } else {
      return sortBy(values, item => item?.name?.toLowerCase())
      // CX121-3021 filter to be displayed case in-sensitive
    }
  }
  */

  handleClick = (key, value) => {
    const { item = {}, filterKey = '' } = this.props
    const name = value.name || ''
    const filterLabelId = `label-${name}-${item.key || ''}-${filterKey}`
    sessionStorage.setItem('lastFocusedFilterLabel', filterLabelId)
    this.props.handleClick(key, value)
  }

  componentDidMount() {
    const lastFocusedLabelId = sessionStorage.getItem('lastFocusedFilterLabel')
    if (lastFocusedLabelId) {
      setTimeout(() => {
        const label = document.getElementById(lastFocusedLabelId)
        if (label) {
          label.focus()
        }
      }, 100)
    }
  }

  colorFacetLabel = (value = {}, name = '') => {
    const colorFacetValue = colorCode[value.name?.toLowerCase()]
    return (
      <div className="d-flex align-items-center">
        <div
          className="color-facet ml-1 border border-light-grey p-0"
          style={{ backgroundColor: colorFacetValue }}
        />
        <span className="ml-2" data-testid={`qa-select-${name}`}>
          {value.name} ({value.count})
        </span>
      </div>
    )
  }

  renderItem = (value = {}, index = 0) => {
    const {
      item = {},
      className = '',
      isFilterChecked = false,
      filterKey = '',
    } = this.props
    const { key = '' } = item
    const isColorFacet = key?.toLowerCase()?.indexOf('color') >= 0

    let name = value.name || ''
    if (
      this.props.filterKey?.toLowerCase() == 'range_facet_price' ||
      this.props.filterKey?.toLowerCase() == 'range_facet_wholesaleprice'
    ) {
      name = this.updatePriceFilterLabelWithCurrency(name)
    }
    const checkedFunction =
      isFunction(isFilterChecked) && application?.isMobile
        ? isFilterChecked(value?.name, key)
        : value.selected

    const dataTestId = value?.selected
      ? 'qa-set-default-checkbox-selected'
      : 'qa-set-default-checkbox'
    const isPresentAndAbove = name?.endsWith('and above')
    const countText = value?.count
      ? '(' + value.count + (isPresentAndAbove ? '+' : '') + ')'
      : ''
    // CX26-597 - hide count text when it is zero
    // sometimes count is zero for "Availability" (facet_inventorystatus)
    // Generate a unique id for each filter
    const filterId = `${name}-${key}-${filterKey}`

    return (
      <div key={filterId}>
        {name && (
          <Form.Check
            className={`plp-filter-checkbox ${className}`}
            key={filterId}
            id={filterId}
            checked={checkedFunction}
            data-focus-id={filterId}
            label={
              isColorFacet ? (
                this.colorFacetLabel(value, item?.name)
              ) : (
                <span
                  role="checkbox"
                  aria-checked={checkedFunction}
                  tabIndex={0}
                  aria-label={`${name} ${checkedFunction}`}
                  id={`label-${name}-${key}-${filterKey}`}
                  data-testid={`qa-select-${item?.name}`}
                  className="paragraph-m check-box-wrap"
                  onKeyDown={event => {
                    if (event.key === 'Enter' || event.key === ' ') {
                      this.handleClick(key, value)
                    }
                  }}>
                  {name} {countText}
                </span>
              )
            }
            data-testid={dataTestId}
            onChange={() => this.handleClick(key, value)}
            aria-label={name}
          />
        )}
      </div>
    )
  }
  isNumeric = (str = '') => {
    if (typeof str != 'string') return false // we only process strings!
    return (
      !isNaN(str) && // use type coercion to parse the _entirety_ of the string (`parseFloat` alone does not do this)...
      !isNaN(parseFloat(str))
    ) // ...and ensure strings of whitespace fail
  }
  updatePriceFilterLabelWithCurrency = (name = '') => {
    const currencySymbol = this.props.currencySymbol || '$'
    let tempName = name
      ?.split(' ')
      ?.map(substring => {
        if (
          this.isNumeric(substring) &&
          isFeatureEnabled('enablePriceFilterCurrencyFormat')
        ) {
          return currencyFormat({
            price: parseFloat(substring),
            currencyWithoutDecimal: true,
          })
        }
        return (this.isNumeric(substring) ? currencySymbol : '') + substring
      })
      .join(' ')
    return tempName || name
  }
  render() {
    const { item } = this.props
    const { values = [], key = '' } = item
    /* 
     discussed this with poovarasan, 
     for filter labels, sorting will be done in backend
      https://nuskin.atlassian.net/browse/CX26-676
     const sortedValues = this.sortValues(values)
     */
    const isMobile = application?.isMobile
    const shouldShowToggle = isMobile && values.length > 5
    const visibleValues =
      shouldShowToggle && !this.state.showAll ? values.slice(0, 5) : values

    return (
      <>
        {isArray(visibleValues) && visibleValues.map(this.renderItem)}
        {shouldShowToggle && (
          <button
            className="btn btn-link text-primary px-0 viewmorebtn"
            onClick={() => this.setState({ showAll: !this.state.showAll })}>
            {this.state.showAll ? (
              enablePlpRedesign() ? (
                <>{viewLessIcon()}Less</>
              ) : (
                'View Less'
              )
            ) : enablePlpRedesign() ? (
              <>{viewMoreIcon()}More</>
            ) : (
              'View More'
            )}
          </button>
        )}
      </>
    )
  }
}

export { ListView }
export default ListView
